import React, { memo, useState, useEffect } from 'react';
import { Grid, Card } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import logo from 'components/Logo/logo-dermpro.svg';
import { Link } from 'react-router-dom';


const useStyles = makeStyles(() => ({
  textHyphenation: {
    hyphens: 'auto',
  }
}));

const BrowsePromoBrandsSearchResults = ({results, debouncedSearchBrand, selectedTab}) => {
  const [searchResults, setSearchResults] = useState(results);
  const classes = useStyles();

  useEffect(() => {
    if (debouncedSearchBrand) {
      setSearchResults(results.filter((brand) =>
        brand.label.toLowerCase().includes(debouncedSearchBrand)
      ));
    } else {
      setSearchResults(results);
    }
  }, [debouncedSearchBrand, results]);

  return (
    <Grid container spacing={4}>
      {searchResults && searchResults.map((brand) => {
        const {_id, label, img} = brand;

        return (
          <Grid item md={2} sm={4} xs={6} key={_id}>
            <Link to={`/browse-promo/${_id}/${selectedTab}`}>
              <Card elevation={25} className={clsx('text-center min-h-200 p-2')}>
                <div className={clsx('h-100 flex items-center justify-center')}>
                  <img
                    src={img}
                    alt={brand.value}
                    className={clsx('max-w-full max-h-100')}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = logo;
                    }}
                  />
                </div>
                <p className={clsx('text-brand font-bold p-2 text-center max-h-60', classes.textHyphenation)}>{label}</p>
              </Card>
            </Link>
          </Grid>
        );
      })}
    </Grid>

  );
};

function brandsPropsAreEqual(prevProp, nextProp) {
  return prevProp.results?.length === nextProp.results?.length
    && prevProp.debouncedSearchBrand === nextProp.debouncedSearchBrand;
}

export default memo(BrowsePromoBrandsSearchResults, brandsPropsAreEqual);

